import { render, staticRenderFns } from "./ElemButton.vue?vue&type=template&id=4de22066&"
import script from "./ElemButton.vue?vue&type=script&lang=js&"
export * from "./ElemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports